export function initializeFbPixel() {
  // Facebook Pixel Code
  !function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () {
      n.callMethod ?
        n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    };
    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
    n.queue = []; t = b.createElement(e); t.async = !0;
    t.src = v; s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s)
  }(window, document, 'script',
    'https://connect.facebook.net/en_US/fbevents.js');

  fbq('init', '453649337409517');
  fbq('track', 'PageView');
}

// Функция для добавления noscript тега
export function addFbPixelNoscript() {
  const noscript = document.createElement('noscript');
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = 'https://www.facebook.com/tr?id=453649337409517&ev=PageView&noscript=1';
  noscript.appendChild(img);
  document.head.appendChild(noscript);
}

// Вспомогательные функции для трекинга событий
export function trackFbEvent(eventName, parameters = {}) {
  if (typeof window !== 'undefined' && window.fbq) {
    fbq('track', eventName, parameters);
  }
}

export function trackFbCustomEvent(eventName, parameters = {}) {
  if (typeof window !== 'undefined' && window.fbq) {
    fbq('trackCustom', eventName, parameters);
  }
} 